const en = {
    app: {
        lang: 'Language',
        edit_pwd: 'Change Password',
        logout: 'Sign Out',
        manage_title: 'Manager System',
        save: 'Save',
        back: 'Back',
        operation: 'operate',
        status: 'Status',
        on: 'On',
        off: 'Off',
        search: 'Search',
        order_no: 'Order NO.',
        start_time: 'Start Time',
        end_time: 'End Time',
        id: 'ID',
        name: 'Name',
        username: 'User Name',
        password: 'Password',
        sort: 'Sort',
        icon: 'Icon',
        route: 'Route',
        desc: 'Description',
        role: 'Role',
        center: 'Center',
        start: 'Start',
        complete: 'Complete',
        edit: 'Edit',
        del_tip: 'Are you sure you want to delete this data?',
        del_m_tip: 'Are you sure you want to delete this data?',
        tip: 'Prompt',
        ok: 'Ok',
        cancel: 'Cancel',
        list: 'List',
        need_sel_one: 'select at least one',
    },
    login: {
        title: 'Manager Login',
        username: 'Username',
        pwd: 'Password',
        verify: 'Verify Code',
        remember: 'Remember Me',
        login: 'Sign In',
    },
    admin: {
        edit_pwd: 'Change Password',
        old_pwd: 'Old Password',
        new_pwd: 'New Password',
        confirm_pwd: 'Confirm Password',
        re_pwd: 'The passwords entered twice do not match!',
    },
    order: {
        list: 'Order List',
        ongoing: 'In Progress',
    },
    user: {
        nickname: 'Nickname',
        manage: 'User Management',
        edit: 'Edit User'
    },
    flow: {
        user: 'Operator',
        cart_no: 'Basket number',
        box_num: 'number of boxes',
        submit_user: 'Operator',
    },
    ftype: {
        1: 'preparer',
        2: 'control',
        3: 'packaging',
        4: 'dispatch',
    },
    wtype: {
        0: 'to prepare',
        1: 'to control',
        2: 'to packaging',
        3: 'to dispatch',
        4: 'finished',
    },
    ontype: {
        0: 'in prepare',
        1: 'in control',
        2: 'in packaging',
        3: 'in dispatch',
    },
    menu: {
        'order': 'Order',
        'stock': 'Prepare',
        'check': 'Control',
        'pack': 'Packaging',
        'close': 'Dispatch',
    },
}

export default en;